export const normalizeLocation = (value) => String(value ?? '').trim().toUpperCase();

const rows = (value) => Array.isArray(value) ? value : [];
const packKey = (financial) => {
  const codes = rows(financial.barcode).length ? financial.barcode : [financial.barcode];
  return String(financial.product_barcode_id || financial.catalogProductBarcodeId ||
    financial.mk_barcode || codes.filter(Boolean).sort()[0] ||
    `${financial.quantity}:${String(financial.units || '').toUpperCase()}`);
};

export const selectLocationFinancials = (financials, location) => {
  const all = rows(financials);
  const outlet = normalizeLocation(location);
  // Once a pack is migrated, its old shared stock must not be sold elsewhere.
  const scopedPacks = new Set(all.filter((f) => normalizeLocation(f.location)).map(packKey));
  return all.filter((f) => {
    const assigned = normalizeLocation(f.location);
    return assigned ? Boolean(outlet) && assigned === outlet : !scopedPacks.has(packKey(f));
  });
};

export const productsForLocation = (products, location) => rows(products).map((product) => ({
  ...product,
  details: rows(product.details).map((detail) => ({
    ...detail,
    financials: selectLocationFinancials(detail.financials, location),
  })).filter((detail) => detail.financials.length),
})).filter((product) => product.details.length);

// Check all cart entry paths, including flat responses from scanner endpoints.
export const resolveLocationCartProduct = (payload, products, location) => {
  const outlet = normalizeLocation(location);
  if (!outlet) throw new Error('Select a cashier location before adding products.');
  const product = rows(products).find((p) => String(p._id) === String(payload.productId || payload.id));
  const detail = rows(product?.details).find((d) => String(d._id) === String(payload.brandId));
  if (detail) {
    const financial = selectLocationFinancials(detail.financials, outlet)
      .find((f) => String(f._id) === String(payload.financialId));
    if (!financial) throw new Error(`This product pack is not available at ${outlet}. Refresh products and select the outlet pack.`);
    return {
      ...payload,
      location: outlet,
      price: financial.price,
      MRP: financial.price,
      dprice: financial.dprice,
      countInStock: financial.countInStock,
      stock: financial.countInStock,
      discount: Number(financial.price) > 0
        ? Math.ceil(Math.max(0, Math.round(Number(financial.price) * 100) - Math.round(Number(financial.dprice) * 100)) / Number(financial.price)) : 0,
    };
  }
  // An uncached lookup must explicitly confirm its outlet; don't trust a global price.
  if (normalizeLocation(payload.location) !== outlet) {
    throw new Error('The barcode lookup did not return financials for this outlet. Refresh products or configure the outlet financials.');
  }
  return { ...payload, location: outlet };
};
